import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { lazyFormatPhoneNumber } from "@faire/retailer-visitor-shared/components/PhoneInput/lazyFormatPhoneNumber";
import { usePhoneNumberValidator } from "@faire/retailer-visitor-shared/components/PhoneInput/phoneNumberValidator";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { logError } from "@faire/web--source/common/logging";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { createToast } from "@faire/web--source/slate/Toast/Toast";
import sendLoggedOutSMS from "@faire/web-api--source/api/app/send-app-store-sms/post";
import sendLoggedInSMS from "@faire/web-api--source/api/app/userToken/send-app-store-sms/post";
import { trackRetailerMobileFooterDesktopappModalsendAppLinkClick } from "@faire/web-api--source/events/retailerMobile/click/footerDesktopAppModalSendAppLink";
import { useEffect, useMemo, useState } from "react";
import { AppDownloadFailureToast, AppDownloadSuccessToast } from "./AppDowanloadToasts";
export var useAppDownloadState = function(afterLinkSent, isLoggedOut) {
    var _usePhoneNumberValidator = usePhoneNumberValidator(), isPending = _usePhoneNumberValidator.isPending, isInvalid = _usePhoneNumberValidator.isInvalid, validatePhoneNumber = _usePhoneNumberValidator.validatePhoneNumber;
    var _useUserStore = useUserStore([
        "phoneNumber",
        "userToken"
    ]), userStorePhoneNumber = _useUserStore.phoneNumber, userToken = _useUserStore.userToken;
    var _useState = _sliced_to_array(useState(function() {
        var number = userStorePhoneNumber !== null && userStorePhoneNumber !== void 0 ? userStorePhoneNumber : "";
        validatePhoneNumber(number);
        return number;
    }), 2), phoneNumber = _useState[0], setPhoneNumber = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), submitted = _useState1[0], setSubmitted = _useState1[1];
    useEffect(function() {
        debounceIfPossible(function() {
            return validatePhoneNumber(phoneNumber);
        }, 400)();
    }, [
        phoneNumber,
        validatePhoneNumber
    ]);
    var isInvalidPhoneNumber = useMemo(function() {
        return submitted ? isInvalid : false;
    }, [
        isInvalid,
        submitted
    ]);
    var sendAppLink = useMemo(function() {
        var sendAppLink = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(eventPrefix) {
                var linkSent, linkSent1, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setSubmitted(true);
                            if (isPending) {
                                setTimeoutIfPossible(function() {
                                    return sendAppLink(eventPrefix);
                                }, 400);
                                return [
                                    2
                                ];
                            }
                            if (isInvalid) {
                                if (isLoggedOut) {
                                    trackRetailerMobileFooterDesktopappModalsendAppLinkClick("failure");
                                }
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                7,
                                8
                            ]);
                            if (!isLoggedOut) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                sendLoggedOutSMS(phoneNumber)
                            ];
                        case 2:
                            linkSent = _state.sent();
                            if (linkSent) {
                                handleSuccess(eventPrefix);
                                trackRetailerMobileFooterDesktopappModalsendAppLinkClick("success");
                            } else {
                                handleFailure(eventPrefix);
                                trackRetailerMobileFooterDesktopappModalsendAppLinkClick("failure");
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            return [
                                4,
                                sendLoggedInSMS(userToken, phoneNumber)
                            ];
                        case 4:
                            linkSent1 = _state.sent();
                            if (linkSent1) {
                                trackEvent("".concat(eventPrefix, "/send-app-link-click/success"));
                                handleSuccess(eventPrefix);
                            } else {
                                trackEvent("".concat(eventPrefix, "/send-app-link-click/failure"));
                                handleFailure(eventPrefix);
                            }
                            _state.label = 5;
                        case 5:
                            return [
                                3,
                                8
                            ];
                        case 6:
                            err = _state.sent();
                            logError(err);
                            handleFailure(eventPrefix);
                            return [
                                3,
                                8
                            ];
                        case 7:
                            afterLinkSent === null || afterLinkSent === void 0 ? void 0 : afterLinkSent();
                            return [
                                7
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return function sendAppLink(eventPrefix) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleSuccess = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(eventPrefix) {
                var formattedPhoneNumber;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                lazyFormatPhoneNumber(phoneNumber)
                            ];
                        case 1:
                            formattedPhoneNumber = _state.sent();
                            createToast(AppDownloadSuccessToast({
                                formattedPhoneNumber: formattedPhoneNumber,
                                onClick: function() {
                                    return sendAppLink(eventPrefix);
                                }
                            }), {
                                timeout: 8000
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleSuccess(eventPrefix) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleFailure = function(eventPrefix) {
            createToast(AppDownloadFailureToast({
                onClick: function() {
                    return sendAppLink(eventPrefix);
                }
            }), {
                timeout: 8000
            });
        };
        return sendAppLink;
    }, [
        isPending,
        isInvalid,
        isLoggedOut,
        phoneNumber,
        userToken,
        afterLinkSent
    ]);
    return {
        phoneNumber: phoneNumber,
        setPhoneNumber: setPhoneNumber,
        isInvalidPhoneNumber: isInvalidPhoneNumber,
        sendAppLink: sendAppLink
    };
};
